import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { Observable} from "rxjs";
import {SaqueBoletoModel} from "./saque-boleto.model";

@Injectable({
  providedIn: 'root'
})
export class SaqueBoletoService {
  constructor(private http: HttpClient)
  {
  }

  sendWithdraw(request : SaqueBoletoModel) : Observable<any>
  {
    return this.http.post<any>(`${environment.apiUrl}/withdraw`, request);
  }

}

